module.exports = __webpack_public_path__ + "static/img/ostaliprihodiirashodi2.36cc468.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kup/tutorial/ostaliprihodiirashodi2.png
// module id = ohPD
// module chunks = 0